<template>
  <nav class="nav-menu-nave">
    <div>
      <b-container class="nave-c-px-4">
        <div class="nav-menu-nave__options">
          <account-select />

          <date-range
            v-if="checkRoute"
            :time="timeOpt"
            @dateUpdated="updateChart($event)"
          />

          <span class="nav-menu-nave__breadcrumb">
            {{ $route.meta.breadcrumb }}
          </span>

          <div class="nav-menu-nave__beta" v-if="checkBeta">
            <span>Versão Beta</span>
            <i
              class="icon-nav-information"
              v-tooltip.top="
                'Essa é uma versão apta para você usar. Contudo, ainda teremos melhorias a serem implementadas. Qualquer sugestão fale com seu Account.'
              "
            />
          </div>
        </div>

        <div class="nav-menu-nave__options">
          <platform-select />

          <user-select />
        </div>
      </b-container>
    </div>
  </nav>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters, mapActions } from "vuex";
import AccountSelect from "@/components/atomic/molecules/accountSelect.vue";
import PlatformSelect from "@/components/atomic/molecules/platformSelect.vue";
import UserSelect from "@/components/atomic/molecules/userSelect.vue";

export default defineComponent({
  name: "NavMenuNave",

  components: {
    AccountSelect,
    PlatformSelect,
    UserSelect,
  },

  data() {
    return {
      timeOpt: [] as Date[],
    };
  },

  mounted() {
    let start = new Date();
    let end = new Date();
    end.setTime(end.getTime() - 7 * 24 * 3600 * 1000);
    start.setTime(start.getTime() - 24 * 3600 * 1000);

    this.timeOpt = [end, start];
  },

  computed: {
    ...mapGetters("date", ["date"]),
    ...mapGetters("loading", ["loading"]),

    checkRoute() {
      return this.$route.meta.showDatePicker;
    },

    checkBeta() {
      return this.$route.meta.showBetaTag;
    },
  },

  methods: {
    ...mapActions("date", ["SET_DATE"]),

    updateChart(event: Date[]) {
      this.SET_DATE([event[0], event[1]]);
    },
  },
});
</script>

<style lang="scss">
.nav-menu-nave {
  position: sticky;
  z-index: 1000;
  top: 0;
  background: linear-gradient(to bottom, #f6f6f6 80%, transparent);
  font-family: "text-medium";

  &::before {
    position: absolute;
    content: "";
    height: 100%;
    width: 100%;
    background: linear-gradient(to bottom, #f6f6f6 80%, transparent);
  }

  > div {
    background: linear-gradient(to bottom, #f6f6f6 80%, transparent);
    padding: 2.4rem 0 2.6rem 0;

    @media (max-width: 1915px) {
      padding: 2.4rem 0 idealWidth(41.6) 0;
    }
  }

  .container {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }

  &__options {
    display: flex;
    align-items: center;
    gap: 22px;
  }

  &__breadcrumb {
    font-size: toRem(16px);
    font-family: "text-medium";
    color: var(--insights-color-16);
    z-index: 1;
  }

  &__beta {
    background: var(--insights-color-22);
    border-radius: 3px;
    color: var(--insights-color-2);
    padding: 0px 9px;
    z-index: 1;

    > span {
      text-transform: uppercase;
      font-size: toRem(13px);
      line-height: 15px;
      font-family: "title-tertiary";
      position: relative;
      top: 1px;
    }

    > i {
      vertical-align: middle;
      font-size: toRem(16px);
      margin-left: 7px;
    }
  }
}
</style>
